
import { Component, Prop, Vue } from 'vue-property-decorator';
import TabItem from '@/ui-components/Tabs/TabItem.vue';
import SkeletonLoading from './SkeletonLoading.vue';
import NoCampaigns from '@/shared-components/NoCampaigns.vue';
import RunningCampaignsTable from './RunningCampaignsTable.vue';
import { RunningCampaign } from '@/types/campaigns';

@Component({
  name: 'RunningCampaigns',
  components: {
    TabItem,
    NoCampaigns,
    SkeletonLoading,
    RunningCampaignsTable,
  },
})
export default class RunningCampaigns extends Vue {
  @Prop({ type: Array, default: () => [] })
  public campaigns!: RunningCampaign[];

  @Prop({ type: Boolean })
  public loading!: boolean;

  @Prop({ type: String })
  public activeTab!: string;
}
